module.exports = __webpack_public_path__ + "static/media/flag-uk.217e2a78.png";